import axiosPrivate from "@services/axiosPrivate";
export const postBillPayment = (formData) => {
  return axiosPrivate.post(`/post-bill-payment`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
